import { InputLabel, TextareaAutosize, TextFieldProps, Tooltip } from '@material-ui/core';
import React, { ReactNode } from 'react';
import { Input } from '../Input';

import { useStyles } from './TextInput.styles';
import clsx from 'clsx';

type Props = {
  errorMessage?: string;
  label?: ReactNode;
  labelId?: any;
  tooltip?: boolean;
  tooltipTitle?: any;
  name?: string;
  placeholder?: string;
  textArea?: boolean;
  textAreaMinRows?: number;
  textAreaMaxLength?: number | undefined;
  classes?: TextFieldProps['classes'] & {
    formRoot?: string;
  };
} & TextFieldProps;
const FormInput: React.FC<Props> = ({
  errorMessage,
  label,
  labelId,
  tooltip,
  tooltipTitle,
  name,
  placeholder,
  type,
  textArea,
  textAreaMinRows,
  textAreaMaxLength = 524288,
  classes: _classes,
  ...props
}) => {
  const classes = useStyles();
  return (
    <div className={clsx(classes.container, _classes?.formRoot)}>
      <InputLabel id={labelId}>
        <span>
          {label}
          {props.required ? <span className={classes.required}>*</span> : null}
        </span>

        {tooltip ? (
          <Tooltip title={tooltipTitle?.toString()}>
            <span>?</span>
          </Tooltip>
        ) : null}
      </InputLabel>
      {textArea ? (
        <TextareaAutosize
          minRows={textAreaMinRows}
          placeholder={placeholder || 'Type here...'}
          name={name}
          className={clsx(
            classes.textAreaCls,
            {
              [classes.withLabel]: label,
            },
            props.className,
          )}
          onChange={props.onChange}
          onBlur={props.onBlur}
          value={props.value as any}
          maxLength={textAreaMaxLength ? textAreaMaxLength : 524288}
          disabled={props.disabled}
        />
      ) : (
        <Input
          variant="outlined"
          // autoFocus
          name={name}
          type={type ? type : 'text'}
          fullWidth
          margin={props.margin || 'normal'}
          InputLabelProps={{ shrink: true }}
          classes={{
            root: _classes?.root,
          }}
          className={clsx(
            {
              [classes.withLabel]: label,
            },
            props.className,
          )}
          // inputProps={{ tabIndex: 1 }}
          placeholder={placeholder}
          errorMessage={errorMessage}
          {...props}
        />
      )}
    </div>
  );
};

export default FormInput;
